module.exports = __webpack_public_path__ + "static/media/badge_corner_passed.ca733c0e.png";